import ajv from '@f/validation/ajv'
import * as UserSchemas from '@f/validation/schema/datalayer/user'
import { IDeactivateSubscription, IUnsubscribe } from '@f/validation/types/dataLayer'

export const validateDeactivateSubscription = ajv.compile<IDeactivateSubscription>(UserSchemas.DeactivateSubscriptionSchema)
export const validateUnsubscribe = ajv.compile<IUnsubscribe>(UserSchemas.UnsubscribeSchema)
